import epsClient from 'enrollment-platform/api/eps.client'

export function updateRehireDate(personPublicKey, rehireDate) {
  if (typeof personPublicKey !== 'string' || personPublicKey === '') {
    return Promise.reject(new Error('Person id is required'))
  }

  const date = rehireDate == null ? '' : String(rehireDate).slice(0, 10)
  return epsClient
    .post(`/core/persons/${personPublicKey}/rehire-date`, { rehireDate: date })
    .then((response) => response.data)
}
